import React from 'react';
import { Shield } from 'lucide-react';
import { Section, SUPPORT_EMAIL, INSTAGRAM_URL } from './Shared';
export const Guarantee = () => <Section className="max-w-3xl" data-id="element-91" data-mp="3ggtz0kj4bn6a">
    <div className="glass-panel gold-frame p-9 md:p-14 rounded-sm text-center" data-id="element-92" data-mp="3gh3ng3oilm9v">
      <Shield className="w-12 h-12 text-brand-gold mx-auto mb-6" data-id="element-93" data-mp="32lrkj907gphv" />
      <p className="font-seal text-xs md:text-sm uppercase tracking-seal text-brand-goldDark mb-4" data-id="element-94" data-mp="36qhdaozkhnyk">
        Garanzia di 7 giorni
      </p>
      <h2 className="text-2xl md:text-3xl font-display font-bold mb-6 text-brand-purpleDark" data-id="element-95" data-mp="3ucxsgbm63rhp">
        Puoi consultare il materiale con calma.
      </h2>
      <p className="text-brand-text/85 mb-6 text-base md:text-lg leading-relaxed" data-id="element-96" data-mp="3ldan5eqbi1jd">
        Se entro 7 giorni ti rendi conto che il pack non è adatto alle tue
        esigenze, puoi richiedere il rimborso secondo le condizioni indicate al
        momento dell’acquisto.
      </p>
      <p className="text-sm text-brand-muted" data-id="element-97" data-mp="2eyt76k7dtxo6">
        Scrivi al supporto e ti guideremo nella procedura.
      </p>
    </div>
  </Section>;
export const Footer = () => <footer className="bg-brand-purpleDark text-brand-surface/80 py-14 border-t border-brand-gold/40" data-id="element-98" data-mp="3lbmuzun6vcgy">
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-99" data-mp="3gctqgrpvqvsx">
      <div className="mb-10" data-id="element-100" data-mp="3v9az3b6opwbs">
        <h2 className="font-seal text-base md:text-lg uppercase tracking-seal text-brand-goldLight mb-4" data-id="element-101" data-mp="3v5dh4svufath">
          Lumen Akasha™
        </h2>
        <p className="text-brand-surface/70 text-sm md:text-base max-w-2xl mx-auto leading-relaxed" data-id="element-102" data-mp="81yv6dh5zo1c">
          Risorse digitali per studiare, organizzare e insegnare con maggiore
          chiarezza.
        </p>
      </div>

      <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 mb-12 text-sm" data-id="element-103" data-mp="hsaeb79f63st">
        <a href={`mailto:${SUPPORT_EMAIL}`} className="hover:text-brand-goldLight transition-colors break-all" data-id="element-104" data-mp="cuija4dha1ke">
          {SUPPORT_EMAIL}
        </a>
        <a href={INSTAGRAM_URL} className="hover:text-brand-goldLight transition-colors" data-id="element-105" data-mp="msg5ynfovqaw">
          @Lumen_Akasha
        </a>
        <a href="https://lumencreativedigital.shop" className="hover:text-brand-goldLight transition-colors" data-id="element-106" data-mp="twfo3t7e3vrw">
          lumencreativedigital.shop
        </a>
      </div>

      <div className="text-xs text-brand-surface/45 space-y-2 border-t border-brand-gold/20 pt-8" data-id="element-107" data-mp="13sr1ynmmotog">
        <p data-id="element-108" data-mp="18kixlckn5plg">© Lumen Akasha 2026. Tutti i diritti riservati.</p>
        <p data-id="element-109" data-mp="18m3o8r3u4oe1">
          I materiali sono destinati all’uso personale. È vietata la
          riproduzione, la vendita o la redistribuzione senza autorizzazione.
        </p>
      </div>

      <p className="mt-8 text-sm font-display italic text-brand-goldLight/70 max-w-2xl mx-auto" data-id="element-110" data-mp="1hiukb3ie038m">
        “Ogni lezione può diventare un nuovo punto di partenza. Oppure può
        inserirsi in un percorso già pensato, con un obiettivo e una
        progressione.”
      </p>
    </div>
  </footer>;